// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomDataForms_title__hzQ-N {
  font-weight: 700;
  font-size: 24px;
  line-height: 32.68px;
  color: #383838;
  margin-top: 1rem;
}

.CustomDataForms_actionButton__9YLw0 {
  display: inline-flex !important;
  cursor: pointer !important;
  color: #873caa;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  padding: 16px 24px 16px 24px;
  border: 1px solid #873caa;
  border-radius: 28px;
  background-color: transparent;
}

.CustomDataForms_viewDataBlock__3d1Je {
  border: solid 1px #e7e0f1;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.CustomDataForms_viewDataBlockFormView__\\+mKgM {
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.CustomDataForms_viewDataBlockItem__Lk6Fj {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10.5px;
  border-radius: 12px;
  border: 1px solid #E7E0F1;
  padding: 16px;
}

.CustomDataForms_viewDataBlockItemValue__rZyAt {
  width: 100%;
  background-color: #eff3f8;
  padding: 10.5px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  min-height: 35px;
}

.CustomDataForms_contentBlockConsent__q-0\\+2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  border-color: #e7e0f1;
  border-width: 1px;
  border-radius: 12px;
  padding: 16px;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.CustomDataForms_viewDataBlockItemValueConsent__ZxG82 {
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  min-height: 35px;
  color: #495057 !important;
}

.CustomDataForms_viewDataBlockItemLabel__oPIxj {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  color: #495057;
}

.CustomDataForms_viewDataBlockItemLabelConsent__CeL84 {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  background-color: #FFFFFF;

}

.CustomDataForms_pageFooter__UD8oL {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  margin-top: 15px;
}

.CustomDataForms_backToTopBtn__TXrqM {
  background-color: #873caa;
  color: white;
  padding: 16px 24px 16px 24px;
  border-radius: 28px;
  font-weight: 600;
  font-size: 16px;
  line-height: 21.79px;
  margin-bottom: 30px;
}

.CustomDataForms_subTitle__6vzjG {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 700;
  line-height: 27.24px;
  color: #383838;
}


.CustomDataForms_customFormAccordion__WSu3f .p-accordion-tab .p-accordion-header:not(.p-disabled) .p-accordion-header-link {
  background: #EEDEF6 !important;
  border-color: #EEDEF6 !important;
  color: #383838 !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  display: flex;
  height: 77px !important;
  padding: 16px !important;
  align-items: center !important;
  align-self: stretch;
}

.CustomDataForms_customFormAccordion__WSu3f .p-accordion-toggle-icon {
  @media (max-width: 767px) {
    margin-bottom: 0px !important;
  }
}

.CustomDataForms_selectButton__ct9c1 .p-button.p-highlight {
  background-color: #F3EFF8 !important;
  color: #495057 !important;
  border-radius: 4px 0px 0px 4px !important;
  border: 1px solid var(--background-tables, #F3EFF8) !important;
  padding: 16px !important;
  font-weight: 400;
  opacity: 1 !important;
}

/*no*/
.CustomDataForms_selectButton__ct9c1 .p-button {
  background-color: #FFFFFF !important;
  color: #999999 !important;
  border-radius: 0px 4px 4px 0px !important;
  border: 1px solid var(--Surface800, #E6E7E8) !important;
  opacity: 0.5 !important;
  padding: 16px !important;
  /* Ensures the button has padding */
}

.CustomDataForms_fieldRow__2yZtX {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.CustomDataForms_fieldColumn__-9mF7 {
  flex: 1 1;
  min-width: 0;
}

.CustomDataForms_checkboxFormViewMode__D0K-K .p-checkbox-box {
  border-radius: 6px !important;
  border-color: #F3EFF8 !important;
  background: var(--Background-tables, #F3EFF8) !important;
  color: #999999 !important;
}

.CustomDataForms_checkboxFormViewMode__D0K-K .p-checkbox-box .p-checkbox-icon {
  color: #999999 !important;
}

.CustomDataForms_labelCheckbox__slJZi {
  color: var(--TextColor, #495057) !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  margin: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/customDataForms/CustomDataForms.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,QAAQ;;EAER;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;;AAGA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,8DAA8D;EAC9D,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,KAAK;AACL;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,uDAAuD;EACvD,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":[".title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32.68px;\n  color: #383838;\n  margin-top: 1rem;\n}\n\n.actionButton {\n  display: inline-flex !important;\n  cursor: pointer !important;\n  color: #873caa;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.79px;\n  padding: 16px 24px 16px 24px;\n  border: 1px solid #873caa;\n  border-radius: 28px;\n  background-color: transparent;\n}\n\n.viewDataBlock {\n  border: solid 1px #e7e0f1;\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.viewDataBlockFormView {\n  border-radius: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.viewDataBlockItem {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10.5px;\n  border-radius: 12px;\n  border: 1px solid #E7E0F1;\n  padding: 16px;\n}\n\n.viewDataBlockItemValue {\n  width: 100%;\n  background-color: #eff3f8;\n  padding: 10.5px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16.34px;\n  min-height: 35px;\n}\n\n.contentBlockConsent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  border-color: #e7e0f1;\n  border-width: 1px;\n  border-radius: 12px;\n  padding: 16px;\n  gap: 8px;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.viewDataBlockItemValueConsent {\n  width: 100%;\n  background-color: #FFFFFF;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16.34px;\n  min-height: 35px;\n  color: #495057 !important;\n}\n\n.viewDataBlockItemLabel {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  color: #495057;\n}\n\n.viewDataBlockItemLabelConsent {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  background-color: #FFFFFF;\n\n}\n\n.pageFooter {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  margin-top: 15px;\n}\n\n.backToTopBtn {\n  background-color: #873caa;\n  color: white;\n  padding: 16px 24px 16px 24px;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21.79px;\n  margin-bottom: 30px;\n}\n\n.subTitle {\n  margin-top: 20px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 27.24px;\n  color: #383838;\n}\n\n\n.customFormAccordion :global(.p-accordion-tab .p-accordion-header:not(.p-disabled) .p-accordion-header-link) {\n  background: #EEDEF6 !important;\n  border-color: #EEDEF6 !important;\n  color: #383838 !important;\n  border-radius: 12px !important;\n  font-size: 16px !important;\n  font-weight: bold !important;\n  display: flex;\n  height: 77px !important;\n  padding: 16px !important;\n  align-items: center !important;\n  align-self: stretch;\n}\n\n.customFormAccordion :global(.p-accordion-toggle-icon) {\n  @media (max-width: 767px) {\n    margin-bottom: 0px !important;\n  }\n}\n\n.selectButton :global(.p-button.p-highlight) {\n  background-color: #F3EFF8 !important;\n  color: #495057 !important;\n  border-radius: 4px 0px 0px 4px !important;\n  border: 1px solid var(--background-tables, #F3EFF8) !important;\n  padding: 16px !important;\n  font-weight: 400;\n  opacity: 1 !important;\n}\n\n/*no*/\n.selectButton :global(.p-button) {\n  background-color: #FFFFFF !important;\n  color: #999999 !important;\n  border-radius: 0px 4px 4px 0px !important;\n  border: 1px solid var(--Surface800, #E6E7E8) !important;\n  opacity: 0.5 !important;\n  padding: 16px !important;\n  /* Ensures the button has padding */\n}\n\n.fieldRow {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 16px;\n  margin-bottom: 16px;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.fieldColumn {\n  flex: 1;\n  min-width: 0;\n}\n\n.checkboxFormViewMode :global(.p-checkbox-box) {\n  border-radius: 6px !important;\n  border-color: #F3EFF8 !important;\n  background: var(--Background-tables, #F3EFF8) !important;\n  color: #999999 !important;\n}\n\n.checkboxFormViewMode :global(.p-checkbox-box .p-checkbox-icon) {\n  color: #999999 !important;\n}\n\n.labelCheckbox {\n  color: var(--TextColor, #495057) !important;\n  font-size: 12px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  margin: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CustomDataForms_title__hzQ-N`,
	"actionButton": `CustomDataForms_actionButton__9YLw0`,
	"viewDataBlock": `CustomDataForms_viewDataBlock__3d1Je`,
	"viewDataBlockFormView": `CustomDataForms_viewDataBlockFormView__+mKgM`,
	"viewDataBlockItem": `CustomDataForms_viewDataBlockItem__Lk6Fj`,
	"viewDataBlockItemValue": `CustomDataForms_viewDataBlockItemValue__rZyAt`,
	"contentBlockConsent": `CustomDataForms_contentBlockConsent__q-0+2`,
	"viewDataBlockItemValueConsent": `CustomDataForms_viewDataBlockItemValueConsent__ZxG82`,
	"viewDataBlockItemLabel": `CustomDataForms_viewDataBlockItemLabel__oPIxj`,
	"viewDataBlockItemLabelConsent": `CustomDataForms_viewDataBlockItemLabelConsent__CeL84`,
	"pageFooter": `CustomDataForms_pageFooter__UD8oL`,
	"backToTopBtn": `CustomDataForms_backToTopBtn__TXrqM`,
	"subTitle": `CustomDataForms_subTitle__6vzjG`,
	"customFormAccordion": `CustomDataForms_customFormAccordion__WSu3f`,
	"selectButton": `CustomDataForms_selectButton__ct9c1`,
	"fieldRow": `CustomDataForms_fieldRow__2yZtX`,
	"fieldColumn": `CustomDataForms_fieldColumn__-9mF7`,
	"checkboxFormViewMode": `CustomDataForms_checkboxFormViewMode__D0K-K`,
	"labelCheckbox": `CustomDataForms_labelCheckbox__slJZi`
};
export default ___CSS_LOADER_EXPORT___;
